<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="videos-detail-title" :field="fields?.title" tag="h1" />
      <div class="videos-detail-share">
        <div class="videos-detail-share-lt">
          <div
            class="videos-detail-share-lt-item"
            v-if="fields?.videosDate?.value !== '0001-01-01T00:00:00Z'"
          >
            <Icon name="date" />
            <span class="videos-detail-share-lt-item-desc">{{
              formatDate(fields?.videosDate?.value)
            }}</span>
          </div>
        </div>
        <div class="videos-detail-share-rt">
          <button
            class="videos-detail-share-rt-share"
            type="button"
            :aria-label="shareAriaLabel"
            @click="handleShare"
          >
            <Icon name="share" />
          </button>
        </div>
      </div>
      <JssRichText class="videos-detail-body" :field="fields?.body" tag="div" />
      <AdaptiveMedia
        class="videos-detail-media"
        :field="fields?.media"
        :show-image-redius="false"
      />
    </ContentGrid>
  </div>
</template>

<script>
import utils from '@/utils';
import { shareToLinkedIn } from '@/utils/dom-utils';

export default {
  name: 'VideosDetail',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
    page: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const rootClass = utils.overall.baseComClass(props.fields, 'videos-detail');

    const rootStyle = utils.overall.baseComStyle(props.fields);

    const formatDate = (dateStr) => {
      if (!dateStr) return '';
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;
      const month = months[date.getMonth()];
      const day = date.getDate();
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    };

    const getShareUrl = () => {
      if (typeof window === 'undefined') return '';
      return window.location.href;
    };

    const shareAriaLabel = 'Share on LinkedIn';

    const handleShare = () => {
      const url = getShareUrl();
      shareToLinkedIn(url);
    };

    return {
      rootClass,
      rootStyle,
      formatDate,
      shareAriaLabel,
      handleShare,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.videos-detail {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-tag {
    font-size: 14px;
    line-height: 1.4;
    color: $blue-night;
    padding: 4px 16px;
    background: #f1f4f1;
    border-radius: 32px;
    display: inline-block;
  }

  &-title {
    margin-top: 16px;
    font-size: 16px;
  }

  &-share {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;

    &-lt {
      display: flex;
      align-items: center;
      gap: 16px;

      &-item {
        display: flex;
        align-items: center;
        gap: 4px;
        svg {
          fill: transparent;
        }
        &-desc {
          font-size: 14px;
          line-height: 1.4;
          color: #656565;
        }
      }
    }

    &-rt {
      display: flex;
      align-items: center;

      &-share {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        justify-self: end;
        width: 40px;
        height: 40px;
        padding: 0;
        color: #111111;
        background: transparent;
        border: 0;
        cursor: pointer;

        svg {
          width: 32px;
          height: 32px;
        }

        &:hover,
        &:focus-visible {
          color: #739b78;
          outline: none;
        }
      }

      &-button {
        margin-left: 16px;
      }
    }
  }

  &-body {
    margin-top: 24px;
    img {
      max-width: 100% !important;
    }
    p {
      font-size: 16px;
    }
    h2 {
      font-size: 22px;
      color: $blue-night;
      margin: 16px 0;
    }
    a {
      color: $blue-night;
    }
  }

  &-media {
    margin: 24px auto;
    width: 100%;
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-title {
      margin-top: 24px;
      font-size: 32px;
    }

    &-share {
      margin-top: 30px;
    }

    &-body {
      margin-top: 40px;
    }

    &-media {
      width: calc(100vw / 24 * 16);
    }
  }
}
</style>
